module.exports = __webpack_public_path__ + "static/media/Rectangle270.85d186ed.svg";